module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"header":{"idAndVersion":"ID a Verze"}},"de":{"header":{"idAndVersion":"ID und Version"}},"es":{"header":{"idAndVersion":"ID y versión"}},"fr":{"header":{"idAndVersion":"Identifiant et version"}}}')
  delete Component.options._Ctor
}
